var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWatchlistRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 117 117",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5 0C26.2 0 0 26.2 0 58.5S26.2 117 58.5 117 117 90.8 117 58.5 90.8 0 58.5 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2 78.112c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2h13.6c.7 0 1.2-.6 1.2-1.2s-.6-1.2-1.2-1.2H33.2zM91.9 39.4L82 78.9v6.2c0 1.4-1.1 2.5-2.4 2.5H54.8c.5-.8.9-1.6 1.2-2.5h23.6v-45H34.8v24.4c-.8.3-1.7.6-2.4 1V40c0-1.4 1.1-2.5 2.4-2.5h6.3l2.5-10.1c.4-1.6 2-2.6 3.7-2.2l42.3 10.5c1.7.4 2.7 2 2.3 3.7zM41 61.2c-.7 0-1.2.6-1.2 1.2 0 .7.6 1.2 1.2 1.2h32.3c.7 0 1.2-.6 1.2-1.2 0-.7-.6-1.2-1.2-1.2H41zm0-11.7c-.7 0-1.2.6-1.2 1.2 0 .7.6 1.2 1.2 1.2h32.3c.7 0 1.2-.6 1.2-1.2 0-.7-.6-1.2-1.2-1.2H41zm33.5 24.7c0 .7-.6 1.2-1.2 1.2H56.4c-.2-.9-.5-1.7-.9-2.5h17.7c.8.1 1.3.7 1.3 1.3zM40.2 93C32.4 93 26 86.9 26 79.3c0-7.5 6.4-13.7 14.2-13.7 7.8 0 14.2 6.1 14.2 13.7.1 7.6-6.3 13.7-14.2 13.7z",
    fill: "#304256"
  }))));
}

export default SvgWatchlistRemove;